import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Logo from './s-tattoo3.jpg'
import "./Nav.css";

const MyNavbar = () => {
  return (
    <div>
      <Navbar
        fixed="top"
        expand="md"
        className="animate-navbar nav-theme justify-content-between"
      >
        <a href = "#home" style = {{marginLeft:"50px", textDecoration:"none"}}>
          
            <h3 style ={{ margin:"auto"}}>Samrat</h3>
          
        </a>
        <div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse style ={{marginRight:"20px"}} id="basic-navbar-nav">
            <Nav className="mr-auto ">
              <Nav.Link href="#home">Home</Nav.Link>
              <Nav.Link href="#about">About</Nav.Link>
              <Nav.Link href="#skills">Skills</Nav.Link>
              <Nav.Link href="#projects">Projects</Nav.Link>
              <Nav.Link href="#contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </div>
  );
};

export default MyNavbar;
